import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import moment from 'moment';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import momentLocalizer from 'react-widgets-moment';

import { Button, Row, Col } from 'react-bootstrap';
import { DateTimePicker } from 'react-widgets';

import linkWithCredentials from '../../../utils/linkWithCredentials';
import { getApiServerUrl } from '../../configuration/selectors';
import { downloadingFileAndUpdatingCredentials } from '../../../utils/downloadUpdatingCredentials';

momentLocalizer();

const propTypes = exact({
  apiServerUrl: PropTypes.string.isRequired,
  showDeferred: PropTypes.bool.isRequired,
});

class SageJobsExporter extends Component {
  constructor(props) {
    super(props);
    this.state = { date: null };
    this.onDateChange = this.onDateChange.bind(this);
    this.handleDeferredDownload = this.handleDeferredDownload.bind(this);
    this.handleSageJobDownload = this.handleSageJobDownload.bind(this);
  }

  onDateChange(e) {
    this.setState({
      date: e,
    });
  }

  handleDeferredDownload() {
    const { date } = this.state;

    if (date === null) {
      return;
    }

    const { apiServerUrl } = this.props;
    const dateStr = moment(date).format('YYYY-MM-DD');
    const pdfLinkCreds = linkWithCredentials(`${apiServerUrl}/deferred_jobs`);
    const pdfUrl = `${pdfLinkCreds}&date=${dateStr}`;
    downloadingFileAndUpdatingCredentials(pdfUrl);
  }

  handleSageJobDownload() {
    const { date } = this.state;

    if (date === null) {
      return;
    }

    const { apiServerUrl } = this.props;
    const dateStr = moment(date).format('YYYY-MM-DD');
    const pdfLinkCreds = linkWithCredentials(`${apiServerUrl}/jobs`);
    const pdfUrl = `${pdfLinkCreds}&date=${dateStr}&sent_to_sage=true`;
    downloadingFileAndUpdatingCredentials(pdfUrl);
  }

  renderDeferred() {
    const maxDate = new Date();
    const { date } = this.state;

    return (
      <div>
        <Col md={9}>
          <DateTimePicker
            placeholder="Select a day to export all deferred jobs"
            time={false}
            onChange={this.onDateChange}
            max={maxDate}
            value={date}
            footer={false}
            views={['year', 'decade']}
          />
        </Col>
        <Col md={3}>
          <Button
            bsStyle="primary"
            disabled={!date}
            onClick={this.handleDeferredDownload}
          >Export
          </Button>
        </Col>
      </div>
    );
  }

  renderSentToSagePerDay() {
    const maxDate = new Date();
    const { date } = this.state;

    return (
      <div>
        <Col md={9}>
          <DateTimePicker
            placeholder="Select a day to export all jobs sent to sage"
            time={false}
            onChange={this.onDateChange}
            max={maxDate}
            value={date}
            footer={false}
          />
        </Col>
        <Col md={3}>
          <Button
            bsStyle="primary"
            disabled={!date}
            onClick={this.handleSageJobDownload}
          >Export
          </Button>
        </Col>
      </div>
    );
  }

  render() {
    const { showDeferred } = this.props;

    return (
      <Row>
        {showDeferred && this.renderDeferred()}
        {!showDeferred && this.renderSentToSagePerDay()}
      </Row>
    );
  }
}

SageJobsExporter.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    apiServerUrl: getApiServerUrl(state),
  };
};

const withRedux = connect(mapStateToProps, {});

const enhance = compose(withRedux);


export default enhance(SageJobsExporter);
